/* ROKZOG core (2026-10-17): the few things every page needs. No Dawn, no dependencies.
   - header: sticks, slides away while scrolling down, comes back when scrolling up; --rz-hd-h = its height
   - selects marked data-rz-autosubmit send their form on change (country / currency)
   - rz.cartCount(n) updates the header's cart count (used by the cart scripts of later phases) */
(function () {
  var rz = window.rz = window.rz || {};

  /* header */
  var sec = document.querySelector('.rz-hd-sec'), hd = sec && sec.querySelector('[data-rz-header]');
  if (sec && hd) {
    var root = document.documentElement, lastY = scrollY, hideOk = !document.querySelector('[data-rz-header][data-pin]');
    var setH = function () { root.style.setProperty('--rz-hd-h', hd.offsetHeight + 'px'); };
    setH(); addEventListener('resize', setH);
    var check = function () {   // a few reads per scroll event: cheap enough to run directly
      // where the header sits before it sticks: under whatever is above it (a stuck element's own offsetTop moves with it)
      var prev = sec.previousElementSibling, top = prev ? prev.offsetTop + prev.offsetHeight : 0, y = Math.max(0, scrollY);
      if (document.documentElement.classList.contains('rz-ov-lock')) { lastY = y; return; }   // the menu is open: leave the header alone
      if (y > lastY + 4 && y > top + hd.offsetHeight * 2 && hideOk) sec.classList.add('is-hidden');
      else if (y < lastY - 4 || y <= top) sec.classList.remove('is-hidden');
      sec.classList.toggle('is-stuck', y > top);
      lastY = y;
    };
    addEventListener('scroll', check, { passive: true });
    // keyboard users always see the header they are tabbing through
    sec.addEventListener('focusin', function () { sec.classList.remove('is-hidden'); });
  }

  /* country / currency */
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (s.matches && s.matches('select[data-rz-autosubmit]') && s.form) s.form.submit();
  });

  /* product cards: the piece line gets the identity label ("· Back print", "· Navy") where two products would look
     the same; again when the full map arrives (page 2+) and when a grid is swapped in place. A card that stands for
     all prints of a piece ("· 3 prints", snippets/rz-print-fold) keeps its line. */
  rz.labelCards = function () {
    if (!window.rzWith) return;
    document.querySelectorAll('.rz-pc [data-rz-kind]:not([data-rz-fold]), .rz-ci [data-rz-kind]').forEach(function (k) {
      var a = k.closest('.rz-pc'); k.textContent = rzWith(k.getAttribute('data-rz-kind'), k.getAttribute('data-u') || (a && a.getAttribute('href')));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rz.labelCards); else rz.labelCards();
  document.addEventListener('rz:ident', rz.labelCards);
  document.addEventListener('rz:grid', rz.labelCards);

  /* cart count in the header */
  rz.cartCount = function (n) {
    document.querySelectorAll('[data-rz-count]').forEach(function (c) { c.textContent = n; c.hidden = !n; });
    document.querySelectorAll('[data-rz-cart-link]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items')); });
  };

  /* added to cart: a pop-up card top-right (the user wants to keep shopping), the header count follows.
     item = the line Shopify returns from /cart/add.js */
  rz.added = function (item) {
    var pop = document.getElementById('rz-pop');
    if (!pop) {
      pop = document.createElement('div'); pop.id = 'rz-pop'; pop.className = 'rz-pop'; pop.setAttribute('role', 'status'); pop.hidden = true;
      pop.innerHTML = '<button type="button" class="rz-pop__x" aria-label="Close">✕</button><p class="rz-label rz-pop__h">Added to cart</p>' +
        '<div class="rz-pop__item"><span class="rz-pop__img"></span><span class="rz-pop__txt"><span class="rz-pop__n"></span><span class="rz-pop__k rz-kind"></span><span class="rz-pop__p"></span></span></div>' +
        '<div class="rz-pop__go"><a class="rz-btn rz-btn--line" data-pop-cart></a><a class="rz-btn" href="/checkout">Check out</a></div>';
      document.body.appendChild(pop);
      pop.querySelector('.rz-pop__x').addEventListener('click', function () { rz.popClose(); });
      pop.addEventListener('mouseenter', function () { clearTimeout(pop._t); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) rz.popClose(); });
    }
    var parts = window.rzParts ? rzParts(item.product_title || item.title) : [item.title];
    pop.querySelector('.rz-pop__n').textContent = parts[0];
    var k = [window.rzWith ? rzWith(parts[1] || '', item.url) : (parts[1] || ''), item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title.replace(/ \/ /g, ' · ') : ''].filter(Boolean).join(' · ');
    pop.querySelector('.rz-pop__k').textContent = k;
    pop.querySelector('.rz-pop__p').textContent = rz.money(item.final_line_price || item.price);
    var im = pop.querySelector('.rz-pop__img'); im.innerHTML = '';
    if (item.image) { var i = new Image(); i.alt = ''; i.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=240'; im.appendChild(i); }
    var cartA = pop.querySelector('[data-pop-cart]'); cartA.href = (rz.routes && rz.routes.cart) || '/cart'; cartA.textContent = 'View cart';
    fetch(((rz.routes && rz.routes.cart) || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { rz.cartCount(c.item_count); cartA.textContent = 'View cart (' + c.item_count + ')'; }).catch(function () {});
    pop.hidden = false; void pop.offsetWidth; pop.classList.add('is-in');
    clearTimeout(pop._t); pop._t = setTimeout(rz.popClose, 7000);
  };
  rz.popClose = function () {
    var pop = document.getElementById('rz-pop'); if (!pop || pop.hidden) return;
    pop.classList.remove('is-in'); setTimeout(function () { pop.hidden = true; }, 350);
  };

  /* money in the shop's own format, e.g. €{{amount_with_comma_separator}} (cents in) */
  rz.money = function (cents) {
    var n = (Number(cents) || 0) / 100, dot = n.toFixed(2), comma = dot.replace('.', ',');
    return String(rz.moneyFormat || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return comma.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (k === 'amount_no_decimals') return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_no_decimals_with_comma_separator') return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return dot.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }).replace(/<[^>]*>/g, '');
  };
})();
